import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { IManuallySetPrice } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  id: string;
  goodItemsIds: string[];
  newPrice: number;
}
export const useManuallySetPrice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, goodItemsIds, newPrice }: HookProps) => {
      const result = await apiClient.declarationsCrud.manuallySetPrice.mutation({
        params: { id },
        body: { goodItemsIds, price: newPrice },
      });
      if (result.status !== 200) throw result.body;

      const { declaration } = result.body.data as IManuallySetPrice;
      return declaration;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Price was set successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error setting the price!`);
    },
  });
};
